/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type SignatureDocumentV1Dto = {
  /**
   * Approver id
   */
  id: string;
  /**
   * Document nature
   */
  nature: SignatureDocumentV1Dto.nature;
};
export namespace SignatureDocumentV1Dto {
  /**
   * Document nature
   */
  export enum nature {
    ATTACHMENT = 'attachment',
    SIGNABLE_DOCUMENT = 'signable_document',
  }
}
